<template>
  <base-dialog-form type="dialog" ref="adminPuntiGaraDialog" :title="infoGara ? infoGara.info.titolo : ''"
    :text="infoGara ? infoGara.info.ragSoc : ''" color="secondary" :icon="infoGara && infoGara.info.type === 'P'
      ? 'mdi-chart-scatter-plot'
      : 'mdi-timer-outline'
      ">
    <template v-slot:actions>
      <v-col cols="12" class="text-center">
        <v-btn class="mx-5" v-if="selectedUser" @click="deleteAllScore" color="error">
          <h3>
            {{ $t("delete_all") }}
          </h3>
        </v-btn></v-col>
    </template>
    <v-container v-if="infoGara && infoGara.info.ifViewVote">
      <v-row>
        <v-col md="6" cols="12">
          <v-autocomplete v-model="selectedUser" :items="infoGara.utenti" item-text="ragSoc" item-value="masterId"
            @change="loadData" dense :label="$t('select_user')"></v-autocomplete>
        </v-col>
        <v-col v-if="votiGara">
          <h3 style="width: 100%; " class="success--text">{{ $t("score") }}: {{ votiGara.totale }}</h3>
        </v-col> <v-col v-if="votiGara">
          <h3 style="width: 100%; " class="primary--text">{{ $t("partial_score") }}: {{ votiGara.totVoti }}</h3>
        </v-col> <v-col v-if="votiGara">
          <h3 style="width: 100%; " class="error--text">{{ $t("penalty") }}: {{ votiGara.totPenalita }}</h3>
        </v-col>
      </v-row>

      <v-row>
        <v-divider></v-divider>
      </v-row>
      <v-row v-if="votiGara">
        <v-simple-table style="width: 100%">
          <thead>
            <tr>
              <th v-if="infoGara.info.ifAdmin" class="text-left primary--text headline">
                {{ $t("delete") }}
              </th>
              <th class="text-left primary--text headline">
                {{ $t("vote_criteria") }}
              </th>
              <th class="text-left primary--text headline">
                {{ $t("score") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="voto in votiGara.tabellaVoti" :key="voto.idSchedaDettaglio">
              <td v-if="infoGara.info.ifAdmin">
                <v-btn style="margin: 0 10px" fab color="error" x-small @click="deleteScore(voto)">
                  <v-icon>mdi-trash-can</v-icon>
                </v-btn>
              </td>
              <td class="success--text headline">{{ getTranslations(voto, "name") }}</td>
              <td class="success--text headline">{{ voto.score }}</td>
            </tr>
            <tr v-for="voto in votiGara.tabellaPenalita" :key="voto.note">
              <td>
                <v-btn style="margin: 0 10px" fab color="error" x-small @click="deleteScore(voto)">
                  <v-icon>mdi-trash-can</v-icon>
                </v-btn>
              </td>
              <td class="error--text headline">
                {{ $t("penalty") }}: {{ voto.descr }}
              </td>
              <td class="error--text headline">{{ voto.score }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-row>
    </v-container>
  </base-dialog-form>
</template>

<script>
import Swal from "sweetalert2";
import { mask } from "vue-the-mask";
export default {
  name: "admin-punti-gara",
  directives: {
    mask,
  },
  data() {
    return {
      idGara: null,
      idGaraPartecipanti: null,
      selectedUser: null,
      infoGara: null,
      votiGara: null,
    };
  },

  methods: {
    getTranslations(voto, type) {
      let locale = localStorage.getItem("selectedLanguage");
      window.navigator.userLanguage || window.navigator.language;
      if (!locale) {
        locale = window.systemData.defaultLanguage;
      }
      if (type === "name") {
        return voto.nameTranslations &&
          voto.nameTranslations[locale] &&
          voto.nameTranslations[locale] !== ""
          ? voto.nameTranslations[locale]
          : voto.name;
      }
      if (type === "descr") {
        return voto.descrTranslations &&
          voto.descrTranslations[locale] &&
          voto.descrTranslations[locale] !== ""
          ? voto.descrTranslations[locale]
          : voto.descr;
      }
      return "????";
    },
    open(idGara, idGaraPartecipanti) {
      this.idGara = idGara;
      this.idGaraPartecipanti = idGaraPartecipanti;
      this.loadUsers();
      this.$refs.adminPuntiGaraDialog.open();
    },
    loadUsers() {
      let _ = this;
      let url =
        "/auth/eventi/getGaraUtentiVoti/" +
        _.idGara +
        "/" +
        _.idGaraPartecipanti;
      _.chiamataAxios("GET", url).then((response) => {
        _.infoGara = response.data;
        if (_.infoGara && _.infoGara.utenti && _.infoGara.utenti.length > 0) {
          _.selectedUser = _.infoGara.utenti[0].masterId;
          _.loadData();
        }
      });
    },
    loadData() {
      let _ = this;
      let url =
        "/auth/eventi/getGaraVoti/" +
        _.idGara +
        "/" +
        _.idGaraPartecipanti +
        "?masterId=" +
        _.selectedUser;
      _.chiamataAxios("GET", url).then((response) => {
        let info = response.data;
        info.tabellaPenalita = info.tabellaPenalita.filter((voto) => {
          return voto.score;
        });
        info.tabellaVoti = info.tabellaVoti.filter((voto) => {
          return voto.score;
        });
        _.votiGara = info;
      });
    },
    deleteScore(voto) {
      let _ = this;
      let testo =
        "<h3>" +
        (voto.type === "P" ? this.$t("penalty") + ": " : "") +
        voto.name +
        "</h3><br><h3>" +
        voto.score +
        "</h3>";
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        html: testo,
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("delete"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          _.chiamataAxios(
            "DELETE",
            "/auth/eventi/deletePunteggioGara/" +
            _.idGara +
            "/" +
            _.idGaraPartecipanti +
            "/" +
            voto.idGareVoti,
            { dialogLoader: true, body: voto }
          ).then((response) => {
            if (response.msg.esito) {
              _.loadData();
            }
          });
        }
      });
    },
    deleteAllScore() {
      let _ = this;
      let giudice = _.infoGara.utenti.filter((utente) => {
        return utente.masterId === _.selectedUser;
      });

      let testo =
        "<h3>" +
        _.$t("delete_all") +
        "</h3><br><h3>" +
        giudice[0].ragSoc +
        "</h3>";
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        html: testo,
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("delete"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          _.chiamataAxios(
            "DELETE",
            "/auth/eventi/deleteAllPunteggioGara/" +
            _.idGara +
            "/" +
            _.idGaraPartecipanti +
            "/" +
            _.selectedUser,
            { dialogLoader: true }
          ).then((response) => {
            if (response.msg.esito) {
              _.loadData();
            }
          });
        }
      });
    },
  },
};
</script>
